var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('navbar-not-logged-in'),_c('b-container',{staticClass:"mt-4 mb-6"},[_c('b-row',[_c('b-col',{attrs:{"lg":""}},[_c('tietosuojaseloste-content')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }